export * from './lib/utils';
export * from './lib/cutsheet-spec-options';
export * from './lib/helper-types';
export * from './lib/processor';
export * from './lib/notifications';
export * from './lib/sms-links';
export * from './lib/us-regions';
export * from './lib/scale-barcode';
export * from './lib/tokens';
export * from './lib/label-draft-ops';
export * from './lib/label-rescale';
export * from './lib/species-yield';
export * from './lib/deposits';
export * from './lib/location-paths';
export * from './lib/stock-aging';
export * from './lib/stock-reasons';
export * from './lib/lead-time';
export * from './lib/email-address';
export * from './lib/kiosk-link';
export * from './lib/split-attention';
export * from './lib/dropoff-confirmation';
export * from './lib/date-range-presets';
export * from './lib/export-filters';
export * from './lib/partner-allowance';

export const generateObjectId = () => {
  const timestamp = Math.floor(Date.now() / 1000)
    .toString(16)
    .padStart(8, '0');

  // Use 5 random bytes (3 for machine ID, 2 for process ID)
  const machineAndProcess = [...crypto.getRandomValues(new Uint8Array(5))]
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('');

  // Use a 3-byte random counter
  const counter = [...crypto.getRandomValues(new Uint8Array(3))]
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('');

  return (timestamp + machineAndProcess + counter).toLowerCase();
};
